import { largestContentfulPaintTime, isIframe } from './browser';
import { isExternal, isInternal } from './document';
import { send, setXsollauidFromUrl } from './request';
import { setCookie } from './cookies';
import { parseData, getHrefWithAnchor } from './util';

export const eventProperties = {
  scrollTimer: null,
  scrollFirst: false,
  scrollMiddle: false,
  scrollBottom: false,
  firstHiddenTime: 0,
  LCP: 0,
};

export const setHandlers = (config, eventForLCP = () => {}) => {
  config.sendLoadMetrics && documentVisibilityChange();
  config.sendLoadMetrics &&
    documentReadyEvent(() =>
      largestContentfulPaintTime(config.sendLoadMetrics, eventForLCP)
    );
  config.hit && documentReadyEvent(() => onDocumentReady(config));
  config.extLink && documentReadyEvent(() => clickEvent(config));
  config.click && documentReadyEvent(() => selectorEvent(config));
  config.scroll && documentReadyEvent(() => scrollEvent(config));
  config.crossDomainTracking &&
    documentReadyEvent(() => externalTransitionEvent(config));
};

export const documentReadyEvent = (func) => {
  if (
    document.attachEvent
      ? document.readyState === 'complete'
      : document.readyState !== 'loading'
  ) {
    func();
  } else {
    document.addEventListener('DOMContentLoaded', func);
  }
};

export const documentVisibilityChange = () => {
  document.addEventListener('visibilitychange', function fn(e) {
    if (document.visibilityState === 'hidden') {
      eventProperties.firstHiddenTime = Math.min(
        eventProperties.firstHiddenTime,
        Math.round(e.timeStamp)
      );
      document.removeEventListener('visibilitychange', fn);
    }
  });
};

export const clickEvent = (config) => {
  const Anchors = document.getElementsByTagName('a');

  for (let i = 0; i < Anchors.length; i++) {
    if (!Anchors[i].eventOnClickIsAssigned) {
      Anchors[i].eventOnClickIsAssigned = true;
      setEvents(Anchors[i], 'click', () => onClick(config));
    }
  }
};

export const onDocumentReady = (config) => {
  const url = window.location.href;
  const data = {
    et: 1,
    url: url,
    eid: config.externalId,
    exv: config.extraValues,
    abParams: config.abParams,
  };

  // no need to send a redirect with the default merchant_id
  if (data.eid && data.eid === 2340) {
    return;
  }

  if (document.referrer) {
    data.referer = document.referrer;
    if (!isExternal(config.siteDomains, data.referer)) {
      data.ss = 1;
    }
    setXsollauidFromUrl(config, url);
  }
  send(config, config.hitUrl, data);
};

export const onClick = (config) => {
  if (isExternal(config.siteDomains, window.location.href)) {
    send(config, config.hitUrl, {
      et: 2,
      referer: window.location.href,
      url: window.location.href,
      eid: config.externalId,
      exv: config.extraValues,
      abParams: config.abParams,
    });
  }
};

export const selectorEvent = (config) => {
  const Anchors = document.querySelectorAll('[data-analytics]');
  for (let i = 0; i < Anchors.length; i++) {
    setEvents(Anchors[i], 'click', () => onSelectorClick(config));
  }
};

export const onSelectorClick = (config) => {
  send(config, config.hitUrl, {
    et: 3,
    url: window.location.href,
    eid: config.externalId,
    exv: config.extraValues,
    abParams: config.abParams,
  });
};

export const scrollEvent = (config) => {
  setEvents(window, 'scroll', () => onScroll(config));
};

export const onScroll = (config) => {
  if (eventProperties.scrollTimer !== null) {
    clearTimeout(eventProperties.scrollTimer);
  }

  eventProperties.scrollTimer = setTimeout(function () {
    // send scroll only if the page does not fit on the screen
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    if (!eventProperties.scrollFirst && scrollTop > 0) {
      eventProperties.scrollFirst = true;
      send(config, config.hitUrl, {
        et: 10,
        url: window.location.href,
        eid: config.externalId,
        exv: config.extraValues,
        abParams: config.abParams,
      });
    }
    if (
      !eventProperties.scrollMiddle &&
      2 * scrollTop > scrollHeight - document.documentElement.clientHeight
    ) {
      eventProperties.scrollMiddle = true;
      send(config, config.hitUrl, {
        et: 11,
        url: window.location.href,
        eid: config.externalId,
        exv: config.extraValues,
        abParams: config.abParams,
      });
    }
    if (
      !eventProperties.scrollBottom &&
      scrollTop >= (scrollHeight - document.documentElement.clientHeight) * 0.9
    ) {
      eventProperties.scrollBottom = true;
      send(config, config.hitUrl, {
        et: 12,
        url: window.location.href,
        eid: config.externalId,
        exv: config.extraValues,
        abParams: config.abParams,
      });
    }
  }, 150);
};

export const externalTransitionEvent = (config) => {
  setEvents(document, 'mousedown', (e) => onExternalTransition(e, config));
  setEvents(document, 'keyup', (e) => onExternalTransition(e, config));
};

export const setEvents = (el, eventType, func) => {
  el.addEventListener
    ? el.addEventListener(eventType, func)
    : el.attachEvent && el.attachEvent('on' + eventType, func);
};

export const onExternalTransition = (e, config) => {
  e = e || window.event;
  let trg = e.target || e.srcElement;
  let l = null;
  for (let i = 100; trg && i > 0; i--) {
    if (trg.href && trg.nodeName.match(/^a(?:rea)?$/i)) {
      l = trg;
      break;
    }
    trg = trg.parentNode;
  }
  l = l || {};
  if (
    ('http:' === l.protocol || 'https:' === l.protocol) &&
    l.href &&
    isInternal(config.siteDomains, l.href)
  ) {
    if (!l.href.includes('_xm=') && config.xsollauid && config.counterId) {
      const newParam = `_xm=${config.counterId}.${config.xsollauid}`;

      if (l.href.includes('?')) {
        l.href = getHrefWithAnchor(l.href, newParam, '?');
      } else {
        l.href = getHrefWithAnchor(l.href, newParam, '&');
      }
    }
  }
};

export const transferDataToIframe = (config) => {
  if (isIframe()) {
    const doHit = config.hit;
    config.hit = false;
    let wasHited = false;
    const onMessageFromMainPage = function (e) {
      const dataFromMainPage = parseData(e.data);
      if (!dataFromMainPage.vid) {
        return;
      }
      window.removeEventListener('message', onMessageFromMainPage);
      config.visitId = dataFromMainPage.vid;
      setCookie('vid', dataFromMainPage.vid, 30, config.counterId);
      if (doHit) {
        wasHited = true;
        documentReadyEvent(() => onDocumentReady(config));
      }
    };
    window.addEventListener('message', onMessageFromMainPage);

    // send a hit from the frame, not ps
    setTimeout(function () {
      if (doHit && !wasHited) {
        documentReadyEvent(() => onDocumentReady(config));
      }
    }, 500);
    return;
  }

  const onMessageFromPs = (e) => {
    const dataFromPs = parseData(e.data);
    if (!dataFromPs.command || dataFromPs.command !== 'open-paystation') {
      return;
    }

    const iframePs = document.querySelector("iframe[class^='xpaystation']");

    if (!iframePs) {
      return;
    }

    const data = {
      vid: config.visitId,
    };

    if (iframePs.contentWindow) {
      iframePs.contentWindow.postMessage(JSON.stringify(data), '*');
    }

    window.removeEventListener('message', onMessageFromPs);
  };

  window.addEventListener('message', onMessageFromPs);
};
